import {
  useAccountAttributeElement,
  useSelectMyPictures,
} from 'affiny-core/hooks';
import { PICTURE_FORMAT } from 'affiny-core/modules/pictures/types';
import { Avatar, Box, Flex, rem, Text } from 'affiny-ui/src';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

export const HeaderProfile = () => {
  const { t } = useTranslation();
  const match = !!useRouteMatch({
    path: '/(profile-edit|my-subscription|settings|criteria)',
    exact: false,
  });

  const myGender = useAccountAttributeElement('gender');
  const { mainPicture } = useSelectMyPictures();

  return (
    <SContainer alignItems="center">
      <Avatar
        size={50}
        mr={rem(12)}
        avatarStyle={{
          border: '4px solid',
          borderColor: 'light',
          boxShadow: 'box',
        }}
        pictureUri={mainPicture?.attributes.formats[PICTURE_FORMAT.SMALL]}
        gender={myGender}
      />
      <Flex flexDirection="column">
        <Text color={match ? 'accent' : 'inherit'} fontWeight="600">
          {t('nav.items.myAccount')}
        </Text>
        {/* <Text color="secondary" variant="small">
          Profil à 80%
        </Text> */}
      </Flex>
      {match && (
        <Box
          width="100%"
          height={rem(4)}
          bg="accent"
          position="absolute"
          bottom={0}
          left={0}
        />
      )}
    </SContainer>
  );
};

const SContainer = styled(Flex)`
  transition: color 300ms ease;
  color: ${({ theme }) => theme.colors.secondary};

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }
`;
